import { areaIsMain } from 'components/base';

export default (routes, area) =>
  routes
    ? routes.map((route) => ({
        ...route,
        path: !areaIsMain(area) ? `/${area.key}${route.path}` : route.path,
      }))
    : undefined;
